import styled from 'styled-components';

export const ApplyTemplateBtnContainer = styled.div`
  position: relative;
  margin: 0px 0px 15px;
`;

export const ApplyTemplateBtn = styled.div`
  font-size: 14px;
  padding: 8px;
  font-weight: 600;
  max-width: 300px;
  margin: auto;
  color: #fff;
  border: 2px solid transparent;
  border-radius: 4px;
  cursor: pointer;
  text-align: center;
  background-color: hsla(0, 0%, 100%, 0.1);
  transition: background-color 0.1s linear, border-color 0.1s linear, color 0.1s linear;
  &:hover {
    background-color: hsla(0, 0%, 100%, 0.15);
    cursor: ${props => !props.editable && 'not-allowed'};
`;
